<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.batch_label_deliveryDate') || '工厂交期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.tips_batch_label_deliveryDate') || '请选择工厂交期'
              "
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_shipmentDate') || '客户交期'
            "
            prop="shipmentDate"
          >
            <el-date-picker
              v-model="formData.shipmentDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.tips_batch_label_shipmentDate') || '请选择客户交期'
              "
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_shipmentEndDate') ||
                '客户交期截止时间'
            "
            prop="shipmentEndDate"
          >
            <el-date-picker
              v-model="formData.shipmentEndDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.tips_batch_label_shipmentEndDate') ||
                  '请选择客户交期截止时间'
              "
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
            prop="cargoReadyDay"
          >
            <el-date-picker
              v-model="formData.cargoReadyDay"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_label_please_select_cargoReadyDay') ||
                  '请选择货好时间'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.batch_label_deliveryType') || '出货方式'"
            prop="deliveryType"
          >
            <dict-select
              filterable
              v-model="formData.deliveryType"
              url="/master/common/dict/biz"
              :body="deliveryTypeParams"
              size="mini"
              :placeholder="
                $l('INDEX.tips_batch_label_deliveryType') || '请选择出货方式'
              "
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.batch_label_outBillType') || '出单类型'"
            prop="outBillType"
          >
            <dict-select
              filterable
              v-model="formData.outBillType"
              url="/master/common/dict/biz"
              :placeholder="
                $l('INDEX.tips_batch_label_outBillType') || '请选择出单类型'
              "
              :body="outBillTypeParams"
              size="mini"
              clearable
              :disabled="orderType"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
            "
            prop="dispatchPort"
          >
            <dict-select
              filterable
              v-model="formData.dispatchPort"
              url="/master/port/select"
              :placeholder="
                $l('INDEX.tips_batch_label_dispatchPort') || '请选择发运港口'
              "
              size="mini"
              clearable
              :disabled="orderType"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
            "
            prop="destinationPort"
          >
            <dict-select
              filterable
              v-model="formData.destinationPort"
              url="/master/port/select"
              :placeholder="
                $l('INDEX.tips_batch_label_destinationPort') || '请选择目的港口'
              "
              :selectedLabel.sync="formData.destinationPortName"
              size="mini"
              clearable
              :disabled="orderType"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_brand') || '品牌'"
            prop="brandCode"
          >
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_brand') || '请选择品牌'
              "
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_form_label_retailerPo') || '零售商PO'"
          >
            <el-input
              clearable
              v-model="formData.retailerPo"
              :placeholder="
                $l('INDEX.order_tips_input_retailerPo') || '请输入零售商PO'
              "
              size="mini"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_form_label_importerPo') || '代理商PO'"
          >
            <el-input
              clearable
              v-model="formData.importerPo"
              :placeholder="
                $l('INDEX.order_tips_input_importerPo') || '请输入代理商PO'
              "
              size="mini"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_identifyNo') || '批次识别单号'
            "
          >
            <identify-input
              size="mini"
              :disabled="disabled"
              :identifyNo.sync="formData.identifyNo"
              :identifyJson.sync="formData.identifyJson"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '请选择批次识别单号'
              "
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('INDEX.tab_demand_packing') || '装箱方案'">
            <el-input clearable v-model="formData.displayFieldOne" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openOrderPackingDialog"
                size="medium"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.total_of_batch') || '批次总数'"
            prop="totQty"
          >
            <el-input
              v-model="formData.totQty"
              size="mini"
              style="width: 100%"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.total_boxes_of_batch') || '批次总箱数'"
            prop="totBoxQty"
          >
            <el-input
              v-model="formData.totBoxQty"
              size="mini"
              style="width: 100%"
              readonly
              v-if="formData.packingType != 'B'"
            ></el-input>
            <el-input-number
              controls-position="right"
              style="width: 100%"
              size="mini"
              :min="0"
              :step="1"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.totBoxQty"
              @change="updateTotBoxQty()"
              v-if="formData.packingType === 'B'"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div>
            <span>
              {{ $l('INDEX.tab_demand_package') || '外包装箱' }} ：
              {{
                formData.displayFieldTwo ? formData.displayFieldTwo : '--'
              }}</span
            >
          </div>
        </el-col>
      </el-row>
      <!-- 订单产品明细 -->
      <good-list
        ref="goodList"
        :orderBatchGoodsList="formData.orderBatchGoodsList"
        :changeOrderCode="changeOrderCode"
        :packingType="formData.packingType"
        @reload="$emit('reload')"
        @saveQty="saveQty"
        :disabled="disabled"
      />
      <ChooseDemandPacking
        :title="$l('INDEX.choose_tab_demand_packing') || '选择装箱方案'"
        :visible.sync="orderPackingDialogVisible"
        :changeOrderCode="changeOrderCode"
        @confirm="choosePackingConfirm"
      />
      <!-- :destinationPortName="formData.destinationPortName" -->
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="mini">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="mini">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="mini">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import GoodList from './goods-list'
import ChooseDemandPacking from './choose-demand-packing/dialog.vue'
export default {
  components: { GoodList, ChooseDemandPacking },
  props: {
    disabled: Boolean,
    isAdd: Boolean,
    code: String,
    changeOrderCode: String,
    isCopy: { type: Boolean, default: false },
  },
  data() {
    return {
      deliveryTypeParams: { dictType: 'deliveryType' },
      outBillTypeParams: { dictType: 'outBillType' },
      backDialogVisible: false,
      orderPackingDialogVisible: false,
      packageGoodsList: [],
      formData: {
        totQty: 0,
        totBoxQty: 0,
        packingType: '',
      },
      orderType: true, //domesticTrade内贸 foreignTrade外贸
      type: 'checkbox',
      rules: {
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_batch_label_deliveryDate') ||
              '请输入工厂交期',
            trigger: 'change',
          },
        ],
        shipmentDate: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_batch_label_shipmentDate') ||
              '请输入客户交期',
            trigger: 'change',
          },
        ],
        cargoReadyDay: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_cargoReadyDay') ||
              '请选择货好时间',
            trigger: 'change',
          },
        ],
        shipmentEndDate: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_batch_label_shipmentEndDate') ||
              '请选择客户交期截止时间',
            trigger: 'change',
          },
        ],
        deliveryType: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_batch_label_deliveryType') ||
              '请选择出货方式',
            trigger: 'change',
          },
        ],
        brandCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_brand') || '请选择品牌',
            trigger: ' change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
    this.getOrderType()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .changeOrderBatchDetailApi({
          changeOrderBatchCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
          if (this.isCopy) {
            this.formData.changeOrderBatchCode = ''
            this.formData.identifyNo = ''
            this.formData.identifyJson = ''
            const batchList = this.formData.orderBatchGoodsList
            batchList.forEach((item) => {
              item.orderBatchGoodsCode = ''
            })
          }
          this.$refs.goodList.updateTable(this.formData.packingType)

          this.formData.displayFieldOne =
            this.formData.v_packingType + ' ' + this.formData.v_outBillType

          this.formData.displayFieldTwo =
            this.formData.materialNo +
            ' | ' +
            this.formData.materialName +
            ' | ' +
            this.formData.materialDisplayName +
            ' | ' +
            this.formData.materialSpec
        })
    },
    //获取订单主信息表的orderType
    getOrderType() {
      if (!this.changeOrderCode) return
      this.$api
        .changeOrderInfoDetailApi({
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.orderType = res.body.orderType === 'domesticTrade'
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      const orderBatchGoodsList = await this.$refs.goodList
        .getTableData()
        .then((res) => {
          if (!res) return
          return res.tableData
        })
      if (!orderBatchGoodsList || !orderBatchGoodsList.length) {
        this.$message.warning('请添加产品信息')
        return
      }

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      //根据不同的操作调用不同接口
      let saveApi = {}
      if (this.isAdd) {
        saveApi = this.$api.changeOrderBatchAddApi({
          ...this.formData,
          changeOrderCode: this.changeOrderCode,
          orderBatchGoodsList: orderBatchGoodsList,
        })
      } else {
        saveApi = this.$api.changeOrderBatchModiApi({
          ...this.formData,
          changeOrderCode: this.changeOrderCode,
          orderBatchGoodsList: orderBatchGoodsList,
        })
      }
      saveApi
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    choosePackingConfirm(data) {
      if (!data) return
      this.formData.materialNo = data.materialNo
      this.formData.totBoxQty = data.totBoxQty

      this.formData.materialName = data.materialName
      this.formData.orderPackingCode = data.orderPackingCode
      // this.formData.packingType = data.packingType
      this.formData.displayFieldOne =
        data.v_packingType + ' ' + data.v_outBillType
      //  +
      // ' ' +
      // data.v_dispatchPort +
      // ' ' +
      // data.v_destinationPort
      this.formData.displayFieldTwo =
        data.materialNo +
        ' | ' +
        data.materialName +
        ' | ' +
        data.materialDisplayName +
        ' | ' +
        data.materialSpec
      this.$api
        .changeAddBatchGoodsByPackingCodeApi({
          changeOrderCode: this.changeOrderCode,
          changeOrderPackingCode: data.changeOrderPackingCode,
          orderGoodsCodeList: data.orderGoodsCodeList,
          totBoxQty: data.totBoxQty,
        })
        .then((res) => {
          this.formData.packingType = res.body.packingType
          this.formData.totQty = res.body.totQty
          this.formData.totBoxQty = res.body.totBoxQty
          this.packageGoodsList = res.body.listGoods
          this.$refs.goodList.addData(this.packageGoodsList)
          this.$refs.goodList.updateTable(this.formData.packingType)
        })
        .catch(() => {})
    },
    openOrderPackingDialog() {
      if (this.formData.orderPackingCode) {
        this.$confirm(
          this.$l('INDEX.Re_selecting_will_clear_product_list') ||
            '重新选择装箱方案会清空产品列表',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText:
              this.$l('INDEX.product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        ).then(() => {
          this.$refs.goodList.delTable()
          this.orderPackingDialogVisible = true
        })
      } else {
        this.orderPackingDialogVisible = true
      }
    },
    saveQty(qty) {
      this.formData.totQty = qty.totQty
      this.formData.totBoxQty = qty.totBoxQty
    },
    updateTotBoxQty() {
      this.$refs.goodList.updateTotBoxQty(this.formData.totBoxQty)
    },
  },
}
</script>
